import React, { useState, useEffect } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';

import { Tienda } from "../../../../../pages/empresa_uno/tienda";
import { Categorias } from "../../../../../pages/empresa_uno/categorias";
import { Proveedores } from "../../../../../pages/empresa_uno/proveedores";
import { Marcas } from "../../../../../pages/empresa_uno/marcas";

import TiendaIcon from "../../../../../svg/tiendaIcon";
import MarcaIcon from "../../../../../svg/marcaIcon";
import CategoriaIcon from "../../../../../svg/categoriaIcon";
import ProveedorIcon from "../../../../../svg/proveedorIcon";
import HistoryIcon from "../../../../../svg/HistoryIcon";
import { useProveedorCompany, Error404 } from '../../../../../components';


import "../../../../../css/table.css";
import { ProductHistory } from "../../../../../pages/empresa_uno/ProductHistory";

const array_subdirectorys = ["productos", "categorias", "marcas", "proveedores", 'historial'];

export const Producto_EU = ({ sucursal_selected, obj_sucursal, setSelected }) => {
	const navigate = useNavigate();

	const { nit, sub_direc } = useParams();

	const { currentBranch, showTable, setShowTable, returnCurrency, historyProducts, setHistoryProducts } = useProveedorCompany();

	const currenRoll = currentBranch?.code ?? "none";

	const pageAllow = {
		V2D0: {
			[array_subdirectorys[0]]: {
				detail: false,
				insert: true,
				edit: true,
				send: true,
				excel: true,
				deleteP: true,
			},
		},
		S3C1: {
			[array_subdirectorys[0]]: {
				detail: false,
				insert: true,
				edit: true,
				send: true,
				excel: true,
				deleteP: true,
			},
		},
		A1M0: {
			[array_subdirectorys[0]]: {
				detail: false,
				insert: true,
				edit: true,
				send: false,
				excel: true,
				deleteP: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				editar: true
			},
			[array_subdirectorys[2]]: {
				leer: true,
				editar: true
			},
		},
		G3R1: {
			[array_subdirectorys[0]]: {
				detail: true,
				insert: true,
				edit: true,
				send: true,
				excel: true,
				deleteP: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				editar: true
			},
			[array_subdirectorys[2]]: {
				leer: true,
				editar: true
			},
			[array_subdirectorys[3]]: {
				leer: true,
				editar: true
			},
			[array_subdirectorys[4]]: {
				leer: true,
				editar: true
			},
		},
		S4A1: {
			[array_subdirectorys[0]]: {
				detail: true,
				insert: true,
				edit: true,
				send: true,
				excel: true,
				deleteP: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				editar: true
			},
			[array_subdirectorys[2]]: {
				leer: true,
				editar: true
			},
			[array_subdirectorys[3]]: {
				leer: true,
				editar: true
			},
			[array_subdirectorys[4]]: {
				leer: true,
				editar: true
			},
		},
	}

	const renderContent = () => {
		if ((!obj_sucursal || obj_sucursal.length === 0) && !sucursal_selected) {
			return <div>No hay sucursales disponibles</div>;
		}

		var allowedForced = null;
		if (currentBranch?.code == "none") return <div> No tienes los permisos suficientes para acceder aquí!</div>

		if (!pageAllow[currenRoll]?.[sub_direc]) {
			if (!pageAllow[currenRoll]) return (<Error404 />);

			const getAllowed = Object.keys(pageAllow[currenRoll]);

			allowedForced = getAllowed[getAllowed.length - 1];
			navigate(`/administrar/negocio/${allowedForced}/${nit}`, { replace: true });
		}

		switch (allowedForced ?? sub_direc) {
			case "productos":
				return (
					<Tienda
						sucursal_selected={sucursal_selected}
						obj_sucursal={obj_sucursal || []}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[0]]}
						myRoll={currenRoll}
						companyID={nit}
						showTable={showTable}
						setShowTable={setShowTable}
					/>
				);
			case "categorias":
				return (
					<Categorias
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[1]]}
					/>
				);
			case "marcas":
				return (
					<Marcas
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[2]]}
					/>
				);
			case "proveedores":
				return (
					<Proveedores
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[3]]}
					/>
				);
			case "historial":
				return (
					<ProductHistory
						sucursal_selected={sucursal_selected}
						convertPrice={returnCurrency}
						obj_sucursal={obj_sucursal || []}
						companyID={nit}
						// permisos={pageAllow[currenRoll]?.[array_subdirectorys[4]]}
						// historyProducts={historyProducts}
						// setHistoryProducts={setHistoryProducts}
					/>
				);
			default:
				return <div>Selecciona una sección</div>;
		}
	};

	const style_modificar = {
		alignItems: 'center',
		background: '#0000',
		border: 'none',
		display: 'flex',
		flexFlow: 'row nowrap',
		gap: '15px',
		height: '60px',
		width: '100%',
	};

	const LogoList = (color, posicion, type) => {
		const arrayList = {
			[array_subdirectorys[0]]: {
				icon: <TiendaIcon size={42} color={color} />,
				text: 'Productos',
			},
			[array_subdirectorys[1]]: {
				icon: <CategoriaIcon size={42} color={color} />,
				text: 'Categorias',
			},
			[array_subdirectorys[2]]: {
				icon: <MarcaIcon size={42} color={color} />,
				text: 'Marca',
			},
			[array_subdirectorys[3]]: {
				icon: <ProveedorIcon size={42} color={color} />,
				text: 'Proveedores',
			},
			[array_subdirectorys[4]]: {
				icon: <HistoryIcon fondo={'transparent'} main_css={{ width: '30px' }} color={color} />,
				text: 'Historial',
			},
		};

		return arrayList[posicion]?.[type];
	}

	return (
		<div className="contenedor-bodys-products" >
			<div className="option-left option-company-left">
				<div className="accion-icons">
					{/* Always show Productos - all roles have access */}
					{
						array_subdirectorys.map((valor, index) => (
							pageAllow[currenRoll]?.[array_subdirectorys[index]] && (
								<NavLink
									to={`/administrar/negocio/${valor}/${nit}`}
									className="item-countain"
									style={{
										...style_modificar,
										backgroundColor: (sub_direc === valor ? 'rgba(0,0,0,0.1)' : 'transparent')
									}}
								>
									<Box sx={{ marginLeft: '10px' }}>
										{LogoList('var(--theme-company)', valor, 'icon')}
									</Box>

									<span style={{ color: 'black', fontWeight: '500' }}>{LogoList('var(--theme-company)', valor, 'text')}</span>
								</NavLink>
							)
						))
					}
				</div>
			</div>

			<div className="floating-menu">
				<button className="default-buttons">
					<MenuIcon sx={{ color: 'var(--theme-company)', fontSize: '50px' }} />
				</button>
				<ul>
					<div style={{ position: 'absolute', top: '0px', left: '0px', height: '100%', width: '100%', backgroundColor: 'var(--theme-company)', zIndex: 0, opacity: .15, filter: 'blur(15px)' }}></div>
					{
						array_subdirectorys.map((valor, index) => (
							pageAllow[currenRoll]?.[array_subdirectorys[index]] && (
								<li style={{ backgroundColor: array_subdirectorys[index] == sub_direc ? 'rgba(0,0,0,0.15)' : 'transparent', zIndex: 2 }}>
									<NavLink
										to={`/administrar/negocio/${valor}/${nit}`}
										style={{
											...style_modificar,
										}}
									>

										<Box>
											{LogoList('var(--theme-main)', valor, 'icon')}
										</Box>

										<span style={{ color: 'var(--theme-main)', fontWeight: '500' }}>{LogoList('var(--theme-main)', valor, 'text')}</span>
									</NavLink>
								</li>
							)
						))
					}
				</ul>
			</div>

			<div id="content-scroll" className="option-right option-company-right">{sub_direc && renderContent()}</div>
		</div>
	);
};
